export const isMobileSelector = (state) => state.isMobile
export const onPlatformSelector = (state) => state.onPlatform
export const authenticityTokenSelector = (state) => state.authenticityToken

export const isCustomStoreSelector = (state) => state.isCustomStore
export const customStoreSelector = (state) => state.customStore
export const showBannerSelector = (state) => state.customStore.showBanner